"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var DropdownNotClosableZone = (function () {
    function DropdownNotClosableZone(elementRef) {
        this.elementRef = elementRef;
    }
    DropdownNotClosableZone.prototype.contains = function (element) {
        if (this.dropdownNotClosabledZone === false)
            return false;
        var thisElement = this.elementRef.nativeElement;
        return thisElement.contains(element);
    };
    return DropdownNotClosableZone;
}());
__decorate([
    core_1.Input("dropdown-not-closable-zone"),
    __metadata("design:type", Boolean)
], DropdownNotClosableZone.prototype, "dropdownNotClosabledZone", void 0);
DropdownNotClosableZone = __decorate([
    core_1.Directive({
        selector: "[dropdown-not-closable-zone]"
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], DropdownNotClosableZone);
exports.DropdownNotClosableZone = DropdownNotClosableZone;
//# sourceMappingURL=DropdownNotClosableZone.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-dropdown/DropdownNotClosableZone.js
// module id = ./node_modules/ngx-dropdown/DropdownNotClosableZone.js
// module chunks = vendor